import { render } from "./TarjetasComponent.vue?vue&type=template&id=1452fc68&scoped=true"
import script from "./TarjetasComponent.vue?vue&type=script&lang=js"
export * from "./TarjetasComponent.vue?vue&type=script&lang=js"

import "./TarjetasComponent.vue?vue&type=style&index=0&id=1452fc68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1452fc68"]])

export default __exports__